/**
 * Created by Jerker Nord on 2024-02-02.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {LonerStatics} from "../LonerStatics";
import {Loner} from "../Loner";
import {LonerGameAssets, TV_SKIN_NAMES} from "../LonerGameAssets";
import {SSDBitmapCountup} from "./features/shootshootduck/SSDBitmapCountup";

export class LonerSymbolTopView extends PIXI.Container implements StageLayer {

   constructor() {
      super();
      this.name = "LonerSymbolTopView";

      this.init();
   }

   private init():void {
      this.position = LonerStatics.MAIN_REELS_VIEW_POSITION;

      let test:SSDBitmapCountup = new SSDBitmapCountup({
         fontName: LonerGameAssets.BITMAP_FONT_SSD_RED,
         fontSize: 40,
         tint: 0xffffff
      }, 1000, new PIXI.Point(1, 0.5));

      test.forceSetText("77889900112233445566xx");

      test.position.set(400, 300);

      //this.addChild(test);
   }
}